import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Button, ButtonGroup, SquareButton, FlexRow } from '../../../../../Styles';
import { Root, Details, ProductName, ProductID, ProductDescription, ProductCategory, ProductPrimary, ProductNameContainer, ProductPrice } from './styles';
import { TrashIcon } from '../../../../../Styles';

const Product = ({ details, disabled = false, selected = false, onSelect, onDelete, ...props }) => {
	return (
		<Root>
			<Details>
				<ProductNameContainer>
					<ProductName>{details?.name}</ProductName>
				</ProductNameContainer>
				{(details?.category || 'add_on' in details) && (
					<FlexRow>
						<ProductPrimary>{details?.add_on ? 'Add-On' : 'Primary'}</ProductPrimary>
						{details?.category && <ProductCategory>{` - ${details?.category}`}</ProductCategory>}
					</FlexRow>
				)}
				<ProductID>{details?.item_id}</ProductID>
				{details?.description && <ProductDescription>{details?.description}</ProductDescription>}
			</Details>

			{!disabled && (
				<ButtonGroup alignRight>
					{selected && (
						<SquareButton
							outline
							error
							disabled={disabled}
							onClick={() => {
								if (onDelete) {
									onDelete(details);
								}
							}}
						>
							<TrashIcon />
						</SquareButton>
					)}

					{!selected && (
						<Button
							outline
							primary
							disabled={disabled}
							onClick={() => {
								if (onSelect) {
									onSelect(details);
								}
							}}
						>
							Select
						</Button>
					)}
				</ButtonGroup>
			)}
		</Root>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatch = {};

export default withRouter(connect(mapStateToProps, mapDispatch)(Product));
